(function(angular){
	'use strict';
	
	var componentNameObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			planData: '<',
			darkTheme: '@'
		},
		controller: ['futureEarningsFactory', HypotheticalPerformanceTableFunction],
		controllerAs: 'hypotheticalPerformanceTable'
	};
	
	angular
		.module('hypotheticalPerformanceModule')
		.component('hypotheticalPerformanceTable', componentNameObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/hypothetical-performance/hypothetical-performance-table.html';
	}
	
	function HypotheticalPerformanceTableFunction(futureEarningsFactory){
		var hypotheticalPerformanceTable = this;

		hypotheticalPerformanceTable.$onInit = function() {
			updateComponent();
		};

		hypotheticalPerformanceTable.$onChanges = function(changesObj) {
			updateComponent();
		};

		function updateComponent() {
			if(hypotheticalPerformanceTable.planData) {
				hypotheticalPerformanceTable.table = {
					income: createLowHighRange(hypotheticalPerformanceTable.planData.currentDividend),
					annual: {
						low: hypotheticalPerformanceTable.planData.projectedAnnualReturnLowerBound,
						high: hypotheticalPerformanceTable.planData.projectedAnnualReturnUpperBound
					}
				};
			}
		}

		function createLowHighRange(number) {
			return {
				low: number * 0.95,
				high: number * 1.05
			};
		}
	}
})(window.angular);